import React from 'react';
import { Button } from 'glic-ui-components';
import { useNavigate } from 'react-router-dom';
import './NotFound.scss';

const Notfound = () => {
  const history = useNavigate();
  return (
    <div id="notfound">
      <div class="notfound">
        <div class="notfound-404">
          <h1>Oops!</h1>
          <h2>404 - The Page can't be found</h2>
        </div>
        <Button
          type="secondary"
          color="navy"
          size="small"
          // eslint-disable-next-line react/jsx-no-bind
          onClick={() => history('/')}
        >
          Click here to go back
        </Button>
      </div>
    </div>
  );
};
export default Notfound;
